import { render, staticRenderFns } from "./SVGPrint2.vue?vue&type=template&id=274b1a9c&scoped=true&"
import script from "./SVGPrint2.vue?vue&type=script&lang=js&"
export * from "./SVGPrint2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b1a9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274b1a9c')) {
      api.createRecord('274b1a9c', component.options)
    } else {
      api.reload('274b1a9c', component.options)
    }
    module.hot.accept("./SVGPrint2.vue?vue&type=template&id=274b1a9c&scoped=true&", function () {
      api.rerender('274b1a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPrint2.vue"
export default component.exports